module.exports = __webpack_public_path__ + "img/portraits_02_V.ca7b2972.webp";